import { useIonRouter } from "@ionic/react";
import { type ReflectionChat } from "@/lib/backend/api";
import { Routes } from "@/lib/router";
import { CoreValueBadge } from "../CoreValue/Badge";
import { ReflectionCard } from "./Card";
import { MultipleChoiceAnswer } from "./MultipleChoiceAnswer";

export function ReflectionChatSummary({
	data,
	...props
}: React.ComponentProps<typeof ReflectionCard> & { data: ReflectionChat }) {
	const router = useIonRouter();

	if (!data.reflection) {
		return <></>;
	}

	return (
		<div className="flex flex-col gap-2">
			<ReflectionCard
				{...props}
				onClick={() => {
					if (data.reflection) {
						router.push(Routes.ReflectionQuestion({ id: data.reflection.id }));
					}
				}}
			>
				<div className="flex flex-col gap-3">
					{data.reflection?.initialQuestion && (
						<p className="text-brown-600 font-semibold">{data.reflection.initialQuestion}</p>
					)}

					{data.initialMessageChosen && data.initialMessageChosen.length > 0 && (
						<MultipleChoiceAnswer selected={data.initialMessageChosen} />
					)}

					{data.initialMessageAnswer && (
						<p className="text-brown-700 font-normal" data-mask-text>
							{data.initialMessageAnswer}
						</p>
					)}
				</div>

				{data.generatedCoreValues.length > 0 && (
					<div className="mt-3 flex flex-col gap-2">
						<div className="flex flex-wrap gap-2">
							{data.generatedCoreValues.map((coreValue) => (
								<CoreValueBadge key={coreValue.id} value={coreValue} />
							))}
						</div>
					</div>
				)}
			</ReflectionCard>
		</div>
	);
}
